/* unplugin-vue-components disabled */import script from "./LightDarkToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./LightDarkToggle.vue?vue&type=script&setup=true&lang=js"

import "./LightDarkToggle.vue?vue&type=style&index=0&id=120eb546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120eb546"]])

export default __exports__